import React, { useEffect, useState } from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { CgWorkAlt } from "react-icons/cg";
import Heading from "./Heading";
import timelimeSymbol from "../util/timelimeSymbol";

function Timeline() {
  const [timelineData, setTimelineData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://raw.githubusercontent.com/anmolkumarshah/data-for-portfolio/main/data.json"
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setTimelineData(data.timeline);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div className="text-white">Loading...</div>;
  }

  if (error) {
    return <div className="text-white">Error: {error}</div>;
  }

  return (
    <div

      className="max-w-[1200px] mx-auto p-5 md:justify-between gap-4"
    >
      <Heading
        id="timeline"
        text={"Timeline"}
        showRight={
          <a href="https://www.linkedin.com/in/anmol-shah-a55694170/">
            Check All Activities
          </a>
        }
      />
      <div>
        <VerticalTimeline>
          {timelineData.map((item, index) => (
            <VerticalTimelineElement
              key={index}
              className="vertical-timeline-element"
              date={item.date}
              iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
              icon={timelimeSymbol(item.icon)}
              dateClassName="font-bold md:text-white text-2xl"
            >
              <h3 className="vertical-timeline-element-title text-xl font-bold">
                {item.title}
              </h3>
              <h4 className="vertical-timeline-element-subtitle font-semibold">
                {item.designation}
              </h4>
              <p className="font-mono">{item.description}</p>
            </VerticalTimelineElement>
          ))}
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;
